// Types
import angular from 'angular';
import { ActionType } from './models/Action';
import { StateViewModelValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/StateViewModelValidator';
import { DESK_ID_PREFIX, STATE_ID_FALLBACK, STATE_ID_END, STATE_ID_ONBOARDING, SUBFLOW_ID_PREFIX, ANSWERS_ID_PREFIX, PAYMENT_ID_PREFIX } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderStateService';
import { ActionsUpdateAndSaveState } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/components/actions/actions.dispatcher';
import { ContentUpdateAndSave } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/contents/contents.dispatcher';
import { OutputAddNewState, OutputAddNewSurvey, OutputChange, OutputUpdateAndSaveState } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { BuilderFeatures } from './BuilderFeatures';
import { ActionTabIAction, ContentActionTabIAction, StateTagsIAction, StateTitleIAction } from './historyActions';
import { BuilderStore } from './store/BuilderStore';
import { validateTab } from './tabs/actions/components/actions/actions.component';
import { validateContentTab } from './tabs/content/components/contents/contents.component';
import { SmartSalesConstants } from './smartSales/SmartSalesConstants';
import { ExclusiveComponentsConstants } from './exclusiveComponents/ExclusiveComponentsConstants';
import './exclusiveComponents/ExclusiveComponents.scss';
import { BuilderAiAgentService as BuilderAiAgentServiceClass } from './services/BuilderAiAgentService';
import { AgentState } from './aiAgent/AiAgentConstants';
import { validateActionViewModelToActionTools } from './aiAgent/utils/AgentUtils';
import { BUILDER_AGENT_KNOWLEDGE_CANCELLED, BUILDER_AGENT_KNOWLEDGE_CONTENT_CANCELLED, BUILDER_AGENT_KNOWLEDGE_CONTENT_OPENED, BUILDER_AGENT_KNOWLEDGE_CONTENT_SAVED, BUILDER_AGENT_KNOWLEDGE_OPENED, BUILDER_AGENT_KNOWLEDGE_SAVED, BUILDER_AGENT_SETTINGS_CANCELLED, BUILDER_AGENT_SETTINGS_OPENED, BUILDER_AGENT_TARGETING_ADDED, } from './aiAgent/events';
import { BUILDER_PAYMENT_TAB_CLICKED } from './payment/events';
const builderStore = BuilderStore.getInstance();
var TagChangesAction;
(function (TagChangesAction) {
    TagChangesAction["AddTag"] = "addTag";
    TagChangesAction["RemoveTag"] = "removeTag";
    TagChangesAction["ChangeTagColor"] = "changeTagColor";
})(TagChangesAction || (TagChangesAction = {}));
export class BuilderSidebarController {
    constructor(TagsService, close, targetState, $scope, states, BuilderSegmentService, ActionContentService, application, //Used in view
    $onStateChanged, $onOutputChange, $onAddNewState, $onAddNewSurvey, ChatService, AccountService2, UndoRedoService, SmartSalesService, AnswersService, $state, $rootScope, AutoSaveService, TranslateService, $translate, SidebarContentService, ExclusiveComponentsService, BuilderAiAgentService, BlipToastService, AiAgentSidebarStateService, AgentSegmentService, PaymentSegmentService, StudioService, $timeout, StudioVersionService) {
        this.TagsService = TagsService;
        this.close = close;
        this.targetState = targetState;
        this.$scope = $scope;
        this.states = states;
        this.BuilderSegmentService = BuilderSegmentService;
        this.ActionContentService = ActionContentService;
        this.application = application;
        this.$onStateChanged = $onStateChanged;
        this.$onOutputChange = $onOutputChange;
        this.$onAddNewState = $onAddNewState;
        this.$onAddNewSurvey = $onAddNewSurvey;
        this.ChatService = ChatService;
        this.AccountService2 = AccountService2;
        this.UndoRedoService = UndoRedoService;
        this.SmartSalesService = SmartSalesService;
        this.AnswersService = AnswersService;
        this.$state = $state;
        this.$translate = $translate;
        this.SidebarContentService = SidebarContentService;
        this.ExclusiveComponentsService = ExclusiveComponentsService;
        this.BuilderAiAgentService = BuilderAiAgentService;
        this.BlipToastService = BlipToastService;
        this.AiAgentSidebarStateService = AiAgentSidebarStateService;
        this.AgentSegmentService = AgentSegmentService;
        this.PaymentSegmentService = PaymentSegmentService;
        this.StudioService = StudioService;
        this.$timeout = $timeout;
        this.StudioVersionService = StudioVersionService;
        this.smartSalesCta = {};
        this.hasInput = false;
        this.isAnswersState = false;
        this.isUndoRedoActionOnTags = false;
        this.isSubflowState = false;
        this.isCtaEnabled = true;
        this.canAddTags = false;
        this.availableAssistants = [];
        this.useConfigurationsApplication = false;
        this.isModelConfigurationOpen = false;
        this.isCatalogManagerModalOpen = false;
        this.isCatalogDocumentsModalOpen = false;
        this.isAiOutputEditModalOpen = false;
        this.isGuardrailModalOpen = false;
        this.isAiSettingsLoading = false;
        this.isCatalogDocumentsLoading = false;
        this.catalogs = [];
        this.agentCatalogs = [];
        this.catalogDocuments = [];
        this.availableModels = [];
        this.isActionModalOpen = false;
        this.isEditActionSchemaModalOpen = false;
        this.isKnowledgeBaseCatalogSelectorOpen = false;
        this.isAiAgentStateOutdated = false;
        this.getSmartSalesLink = async () => {
            this.SmartSalesService.setTokenApplicationByState(this.state);
            const { shortnedLink } = await this.SmartSalesService.createUserSession('user-test');
            return shortnedLink;
        };
        this.handleSmartSalesButtonClick = async () => {
            const catalogLink = await this.getSmartSalesLink();
            window.open(catalogLink, '_blank');
        };
        this.handleSelectedAssistantChanges = async (event) => {
            const currentState = angular.copy(this.state);
            const leavingActions = [
                {
                    ...currentState.$leavingCustomActions[0],
                    settings: {
                        ...currentState.$leavingCustomActions[0].settings,
                        AssistantId: event.detail.value,
                    },
                },
            ];
            this.state.$leavingCustomActions = leavingActions;
            this.$onStateChanged(this.state);
        };
        this.onTabChange = async (event) => {
            if (event?.detail?.id != 'aiInstructionsTab') {
                this.closeModelAdjustmentModal();
                this.closeModalGuardrail();
            }
            if (event?.detail?.id != 'aiOutputTab') {
                this.closeAiOutputEditModal();
            }
            if (event?.detail?.id != 'knowledgeTab') {
                this.closeCatalogManagerModal();
                this.closeCatalogDocumentsModal();
            }
            if (event?.detail?.id != 'actionsTab') {
                this.closeSchemaEditor();
                this.AiAgentSidebarStateService.close();
            }
            if (event?.detail?.id == 'paymentMethodTab') {
                this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_TAB_CLICKED, { tabName: 'PaymentMethod' });
            }
            if (event?.detail?.id == 'paymentInformationTab') {
                this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_TAB_CLICKED, { tabName: 'Information' });
            }
            if (event?.detail?.id == 'paymentConfigurationTab') {
                this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_TAB_CLICKED, { tabName: 'Configuration' });
            }
            if (event?.detail?.id == 'paymentOutputConfigurationTab') {
                this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_TAB_CLICKED, { tabName: 'OutputCondition' });
            }
        };
        this.onCtaInputChange = (event) => {
            const field = event.target.dataset?.cta;
            const validFields = ['header', 'body', 'footer', 'button'];
            if (!validFields.includes(field)) {
                return;
            }
            this.smartSalesCta[field] = event.detail.value;
        };
        this.resetCtaInformation = async () => {
            this.smartSalesCta = {
                header: await this.$translate('builder.smartSales.defaultCtaMessage.header'),
                body: await this.$translate('builder.smartSales.defaultCtaMessage.body'),
                footer: await this.$translate('builder.smartSales.defaultCtaMessage.footer'),
                button: await this.$translate('builder.smartSales.defaultCtaMessage.button'),
            };
            this.updateCtaInTheState();
        };
        this.updateCtaInTheState = () => {
            if (!this.smartSalesCta.body.length || !this.smartSalesCta.button.length) {
                return;
            }
            this.state.$enteringCustomActions.find(action => action.$title === SmartSalesConstants.WA_CTA_ACTION_NAME).settings.value = JSON.stringify(this.smartSalesCta);
        };
        this.updateBlipChatCopyAndPasteInTheState = (document) => {
            this.state.$contentActions.find(action => action.action.settings.type === ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE).action.settings.rawContent = JSON.stringify(document.content);
        };
        this.isCtaAvailable = () => {
            return this.SmartSalesService.isStateVersionAvailableToCta(this.state.stateVersion);
        };
        this.isCtaAvailableToggle = () => {
            return this.SmartSalesService.isStateVersionAvailableToCtaToggle(this.state.stateVersion);
        };
        this.isSmartSalesStateOutdated = () => {
            return !(this.SmartSalesService.isSmartSalesStateVersionUpToDate(this.state.stateVersion));
        };
        this.toggleCta = async (event) => {
            this.isCtaEnabled = event.detail.checked;
            this.state.$enteringCustomActions.find(action => action.$title === SmartSalesConstants.WA_WEB_ACTION_NAME).settings.value = JSON.stringify(event.detail.checked);
            this.$scope.$apply();
        };
        this.openModelAdjustmentModal = () => {
            this.isModelConfigurationOpen = true;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_SETTINGS_OPENED);
        };
        this.closeModelAdjustmentModal = async () => {
            if (!this.isModelConfigurationOpen) {
                return;
            }
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_SETTINGS_CANCELLED);
            this.isModelConfigurationOpen = false;
        };
        this.saveModelConfiguration = async ($previous) => {
            this.isModelConfigurationOpen = false;
            await this.setAgentConfigurationContent();
            this.AgentSegmentService.trackAiAgentConfiguration({
                after: this.agentConfiguration,
                before: $previous,
            });
        };
        this.openCatalogManagerModal = () => {
            this.closeCatalogDocumentsModal();
            this.isCatalogManagerModalOpen = true;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_OPENED);
        };
        this.closeCatalogManagerModal = async () => {
            if (!this.isCatalogManagerModalOpen) {
                return;
            }
            this.isCatalogManagerModalOpen = false;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CANCELLED);
        };
        this.openCatalogDocumentsModal = async (params) => {
            this.AgentSegmentService
                .trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CONTENT_OPENED, { catalogName: params.agentCatalog.name });
            this.closeCatalogManagerModal();
            this.catalogDocuments = [];
            this.isCatalogDocumentsModalOpen = false;
            this.isCatalogDocumentsLoading = true;
            this.isCatalogDocumentsModalOpen = true;
            this.openedAgentCatalog = params.agentCatalog;
            this.catalogDocuments = await this.BuilderAiAgentService.getCatalogDocuments(params.agentCatalog.id, this.state.id, AgentState.DEVELOPMENT) ?? [];
            this.isCatalogDocumentsLoading = false;
        };
        this.closeCatalogDocumentsModal = async () => {
            if (!this.isCatalogDocumentsModalOpen) {
                return;
            }
            this.isCatalogDocumentsModalOpen = false;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CONTENT_CANCELLED);
        };
        this.openAiOutputEditModal = async ($output, $index) => {
            this.selectedOutput = { $output, $index };
            this.isAiOutputEditModalOpen = true;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_TARGETING_ADDED);
        };
        this.closeAiOutputEditModal = async () => {
            if (!this.isAiOutputEditModalOpen) {
                return;
            }
            this.isAiOutputEditModalOpen = false;
        };
        this.saveCatalogManagerModal = async (params) => {
            this.isAiSettingsLoading = true;
            const commandResult = await this.BuilderAiAgentService.setAgentCatalogsOnApa(params.agentCatalogs, this.state.id, AgentState.DEVELOPMENT);
            if (commandResult?.status === 'success') {
                this.BlipToastService.show('success', {
                    title: await this.$translate('builder.knowledgeToast.success.saveCatalogToastTitle'),
                    msg: await this.$translate('builder.knowledgeToast.success.saveCatalogToastMessage'),
                });
            }
            else {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('builder.knowledgeToast.error.saveCatalogToastTitle'),
                    msg: await this.$translate('builder.knowledgeToast.error.saveCatalogToastMessage'),
                });
            }
            this.catalogs = await this.BuilderAiAgentService.getCatalogs(this.state.id, AgentState.DEVELOPMENT) ?? [];
            this.agentCatalogs = this.catalogs.filter(catalog => catalog.status == 'active');
            await this.BuilderAiAgentService.updateMcpToolConfiguration(this.state, this.agentCatalogs);
            this.isAiSettingsLoading = false;
            this.isCatalogManagerModalOpen = false;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_SAVED);
            this.$onStateChanged(this.state);
        };
        this.saveCatalogDocumentsModal = async (params) => {
            this.isAiSettingsLoading = true;
            const commandResult = await this.BuilderAiAgentService.normalizeAndSetDocuments(params.catalogId, params.inactiveCatalogDocuments, this.state.id, AgentState.DEVELOPMENT);
            if (commandResult?.status === 'success') {
                this.BlipToastService.show('success', {
                    title: await this.$translate('builder.knowledgeToast.success.saveCatalogDocumentToastTitle'),
                    msg: await this.$translate('builder.knowledgeToast.success.saveCatalogDocumentToastMessage'),
                });
            }
            else {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('builder.knowledgeToast.error.saveCatalogDocumentToastTitle'),
                    msg: await this.$translate('builder.knowledgeToast.error.saveCatalogDocumentToastMessage'),
                });
            }
            this.catalogs = await this.BuilderAiAgentService.getCatalogs(this.state.id, AgentState.DEVELOPMENT) ?? [];
            this.agentCatalogs = this.catalogs.filter(catalog => catalog.status == 'active');
            await this.BuilderAiAgentService.updateMcpToolConfiguration(this.state, this.agentCatalogs);
            this.isAiSettingsLoading = false;
            const catalogName = this.catalogs.find(catalog => catalog.id == params.catalogId)?.name;
            this.isCatalogDocumentsModalOpen = false;
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CONTENT_SAVED, { catalogName });
            this.$onStateChanged(this.state);
        };
        this.openModalGuardrail = () => {
            this.isGuardrailModalOpen = true;
        };
        this.closeModalGuardrail = () => {
            if (!this.isGuardrailModalOpen) {
                return;
            }
            this.isGuardrailModalOpen = false;
        };
        this.saveAgentInstructions = async () => {
            await this.setAgentConfigurationContent();
        };
        this.savePaymentConfiguration = async () => {
            await this.setPaymentConfigurationContent();
        };
        this.onPaymentInformationChange = (informationData) => {
            if (!this.paymentConfiguration) {
                this.paymentConfiguration = { configuration: {}, customize: {}, paymentMethod: {}, information: {} };
            }
            this.paymentConfiguration.information = { ...this.paymentConfiguration.information, ...informationData };
            this.savePaymentConfiguration();
        };
        this.onPaymentConfigurationChange = (configurationData) => {
            if (!this.paymentConfiguration) {
                this.paymentConfiguration = { configuration: {}, customize: {}, paymentMethod: {}, information: {} };
            }
            this.paymentConfiguration.configuration = { ...this.paymentConfiguration.configuration, ...configurationData };
            this.updatePaymentSetVariableAction('configurationData', configurationData);
            this.savePaymentConfiguration();
        };
        this.onPaymentMethodChange = (paymentMethodData) => {
            if (!this.paymentConfiguration) {
                this.paymentConfiguration = { configuration: {}, customize: {}, paymentMethod: {}, information: {} };
            }
            this.paymentConfiguration.paymentMethod = { ...this.paymentConfiguration.paymentMethod, ...paymentMethodData };
            this.updatePaymentSetVariableAction('paymentMethodData', paymentMethodData);
            this.savePaymentConfiguration();
        };
        this.saveOutputState = async () => {
            builderStore.setState(angular.copy(this.state));
        };
        this.onOpenActionModal = () => {
            this.isActionModalOpen = true;
        };
        this.onCloseActionModal = () => {
            this.isActionModalOpen = false;
        };
        this.openSchemaEditor = ($action) => {
            this.isEditActionSchemaModalOpen = true;
            this.currentAction = $action;
        };
        this.closeSchemaEditor = () => {
            if (!this.isEditActionSchemaModalOpen) {
                return;
            }
            this.isEditActionSchemaModalOpen = false;
            this.currentAction = undefined;
        };
        this.onSaveActionSchema = async ($action) => {
            this.isEditActionSchemaModalOpen = false;
            this.currentAction = undefined;
            const { errors } = validateActionViewModelToActionTools($action, this.state);
            if (errors.length > 0) {
                return;
            }
            const generatedMCPResource = await this.saveThisStateToolsOnApa($action.type);
            if (!generatedMCPResource) {
                return;
            }
            this.updateAgentState($action, generatedMCPResource);
            await this.setAgentConfigurationContent();
            this.BlipToastService.show('success', {
                title: this.$translate.instant('ai-agent-toasts.builder-save-mcp-tool-success.title'),
                msg: this.$translate.instant('ai-agent-toasts.builder-save-mcp-tool-success.message'),
            });
        };
        this.saveThisStateToolsOnApa = async (actionType) => {
            const currentState = angular.copy(this.state);
            const extractMethod = actionType === ActionType.KnowledgeBaseConsult
                ? this.BuilderAiAgentService.extractAiAgentsGroundingLocalCustomActionsToPublish.bind(this.BuilderAiAgentService)
                : this.BuilderAiAgentService.extractAiAgentsLocalCustomActionsToPublish.bind(this.BuilderAiAgentService);
            const generatedMCPResource = await extractMethod(currentState, AgentState.DEVELOPMENT);
            if (!generatedMCPResource) {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('ai-agent-toasts.builder-save-mcp-tool-error.title'),
                    msg: await this.$translate('ai-agent-toasts.builder-save-mcp-tool-error.message'),
                });
                return null;
            }
            return generatedMCPResource;
        };
        /**
         * Handle history variable selection from sidebar
         * Broadcasts the selected variable to child components via the service
         */
        this.onHistoryVariableSelect = (variableName) => {
            // Store the selected variable in the service data for components to consume
            this.AiAgentSidebarStateService.open('historyVariable', {
                selectedVariable: variableName,
                currentVariable: '',
            });
            // Close the sidebar after a short delay to allow components to read the data
            setTimeout(() => {
                this.AiAgentSidebarStateService.close();
            }, 100);
            // Trigger digest cycle to update bindings
            if (!this.$scope.$$phase) {
                this.$scope.$apply();
            }
        };
        /**
         * Handle history config update from sidebar
         * Broadcasts the updated config to child components via the service
         */
        this.onHistoryConfigSelect = (config) => {
            // Store the updated config in the service data for components to consume
            this.AiAgentSidebarStateService.open('historyConfig', {
                updatedConfig: config,
            });
            // Close the sidebar after a short delay to allow components to read the data
            setTimeout(() => {
                this.AiAgentSidebarStateService.close();
            }, 100);
            // Trigger digest cycle to update bindings
            if (!this.$scope.$$phase) {
                this.$scope.$apply();
            }
        };
        this.isAssistantLoading = true;
        this.stateViewModelValidator = new StateViewModelValidator();
        AutoSaveService.registerAction($rootScope, this, this.updateAndSaveState.bind(this));
        this.showDetail = false;
        this.inputValidationRules = [];
        this.currentLanguage = TranslateService.getCurrentLanguage();
        this.isDeskState = this.targetState.id.startsWith(DESK_ID_PREFIX);
        this.isSmartSalesState = this.targetState.id.startsWith(SmartSalesConstants.STATE_ID_PREFIX);
        this.isBlipChatCopyAndPaste = this.targetState.id.startsWith(ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_PREFIX);
        this.isAnswersState = this.targetState.id.startsWith(ANSWERS_ID_PREFIX);
        this.isAiAgentState = BuilderAiAgentServiceClass.isAiAgentState(this.targetState.id);
        this.isPaymentState = this.targetState.id.startsWith(PAYMENT_ID_PREFIX);
        this.init();
        this.addContentEnabled =
            this.targetState.id != STATE_ID_ONBOARDING &&
                this.targetState.id != STATE_ID_FALLBACK &&
                this.targetState.id != STATE_ID_END &&
                !this.isDeskState &&
                !this.isSmartSalesState &&
                !this.isBlipChatCopyAndPaste &&
                !this.isAiAgentState &&
                !this.isPaymentState;
        this.hasOutputTab = this.targetState.id !== STATE_ID_END && !this.isPaymentState;
        this.hasActionsTab = this.targetState.id !== STATE_ID_END && !this.isDeskState && !this.isSmartSalesState && !this.isAnswersState && !this.isPaymentState;
        this.account = {};
    }
    async init() {
        /**
         * Avoid to refactor all view variables when undo/redo
         * feature is unabled
         * */
        this.state = this.targetState;
        await this.checkFeatures();
        this.isSubflowState = this.state.id.includes(SUBFLOW_ID_PREFIX);
        this.canAddTags = this.isSubflowState;
        this.oldState = { ...this.state };
        this.startSubscribers();
        this.initializeProxy();
        this.account = await this.AccountService2.me();
        this.BuilderSegmentService.setApplication(this.application);
        this.SmartSalesService.setApplication(this.application, this.useConfigurationsApplication);
        this.defaultTextMsg = await this.$translate('builder.smartSales.cta.configure.defaultCatalogMessage');
        // Remove the BLiP Chat Widget
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        if (this.isAnswersState) {
            this.availableAssistants = (await this.AnswersService.getPublishedAssistants()).map(assistant => ({ value: assistant.assistantId, label: assistant.assistantName }));
            this.isAssistantLoading = false;
        }
        if (this.isSmartSalesState) {
            await this.initSmartSales();
        }
        if (this.isBlipChatCopyAndPaste) {
            const blipChatCopyAndPasteDocument = this.ExclusiveComponentsService.getBlipChatCopyAndPaste(this.state, this.updateBlipChatCopyAndPasteInTheState);
            this.blipChatCopyAndPaste = blipChatCopyAndPasteDocument;
        }
        if (this.isAiAgentState) {
            await this.initAiAgent();
            this.isStudioEnabled = await this.StudioService.shouldEnableStudioFeatures();
        }
        if (this.isPaymentState) {
            await this.initPayment();
        }
    }
    async initSmartSales() {
        this.smartSalesLink = await this.getSmartSalesLink();
        const ctaInfo = this.SmartSalesService.getCtaInformation(this.state);
        const isCtaenabled = this.SmartSalesService.getSmartSalesWebLinkEnabled(this.state);
        if (ctaInfo) {
            this.smartSalesCta = ctaInfo;
        }
        if (isCtaenabled !== undefined) {
            this.isCtaEnabled = isCtaenabled;
            this.state
                .$enteringCustomActions
                .find(action => action.$title === SmartSalesConstants.DEFAULT_DISABLED_CTA_ACTION_NAME).settings.value = this.defaultTextMsg;
        }
    }
    async initAiAgent() {
        this.isAiSettingsLoading = true;
        this.agentConfiguration = await this.BuilderAiAgentService.getAgentConfiguration(this.state);
        this.availableModels = await this.BuilderAiAgentService.getAvailableModels();
        this.catalogs = await this.BuilderAiAgentService.getCatalogs(this.state.id, AgentState.DEVELOPMENT) ?? [];
        this.agentCatalogs = this.catalogs?.filter(catalog => catalog.status == 'active');
        this.isAiSettingsLoading = false;
        this.AgentSegmentService.setState(this.state);
        this.hasAgentBlockToUpdate = this.BuilderAiAgentService.isAgentBlockOutdated(this.state);
        this.latestVersion = this.BuilderAiAgentService.getAgentBlockLatestVersion();
        this.isAiAgentStateOutdated = !(this.BuilderAiAgentService.isAgentVersionUpToDate(this.state));
    }
    async initPayment() {
        this.PaymentSegmentService.setState(this.state);
        this.loadPaymentConfigurationFromState();
    }
    startSubscribers() {
        const stateChanges$ = builderStore.getStateChanges()
            .subscribe(data => {
            if (data?.id && data.id === this.targetState.id) {
                const updatedData = angular.copy(data);
                /**
                 * Update every property avoid override Proxy because
                 * changes still need to be watched
                 */
                for (const prop in updatedData) {
                    if (updatedData.hasOwnProperty(prop)) {
                        this.targetState[prop] = updatedData[prop];
                    }
                }
                this.updateAndSaveState();
            }
        });
        this.$scope.$on('$destroy', () => {
            stateChanges$.unsubscribe();
        });
    }
    async checkFeatures() {
        this.isBuilderUndoRedoContentEnabled = await BuilderFeatures.builderUndoRedoContentEnabled();
        this.isBuilderUndoRedoActionEnabled = await BuilderFeatures.builderUndoRedoActionEnabled();
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
        this.isBuilderUndoRedoBlockTagEnabled = await BuilderFeatures.builderUndoRedoBlockTagEnabled();
        this.isBuilderUndoRedoBlockNameEnabled = await BuilderFeatures.builderUndoRedoBlockNameEnabled();
        this.isBuilderAddOutputConditionsOnContentChange = await BuilderFeatures.builderAddOutputConditionsOnContentChange();
        this.useConfigurationsApplication = await BuilderFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.isStudioVersioningEnabled = await BuilderFeatures.isStudioVersioningEnabled();
    }
    initializeProxy() {
        this.state = new Proxy(this.targetState, {
            set: (target, key, value) => {
                switch (key) {
                    case 'this.state.$contentActions':
                        this.handleContentActionChanges(value);
                        break;
                    case 'this.state.$enteringCustomActions':
                        this.handleActionsChanges(key, value);
                        break;
                    case 'this.state.$leavingCustomActions':
                        this.handleActionsChanges(key, value);
                        break;
                    case 'this.state.$localCustomActions':
                        this.handleActionsChanges(key, value);
                        break;
                    default:
                        // just pass through
                        break;
                }
                return Reflect.set(target, key, value);
            },
        });
    }
    /**
     * Handle proxy changes to made undo/redo
     * @param value
     */
    handleContentActionChanges(contentActions) {
        if (!this.isBuilderUndoRedoContentEnabled) {
            return;
        }
        let allOutputConditions = angular.copy(this.state.$conditionOutputs);
        if (this.isBuilderAddOutputConditionsOnContentChange) {
            contentActions.forEach(contentAction => {
                allOutputConditions = this.ActionContentService.getAllOutputConditions(contentAction, this.state.$conditionOutputs) || allOutputConditions;
            });
        }
        const changeContentTabIAction = new ContentActionTabIAction({
            execute: (data) => {
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                    $contentActions: data.after,
                    $conditionOutputs: allOutputConditions,
                });
                validateContentTab(this.state);
            },
            undo: (data) => {
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                    $contentActions: data.before,
                    $conditionOutputs: data.outputConditionsBefore,
                });
                validateContentTab(this.state);
            },
            data: {
                after: angular.copy(contentActions),
                before: angular.copy(this.state.$contentActions),
                outputConditionsBefore: this.state.$conditionOutputs,
                state: {
                    id: this.state.id,
                    $title: this.state.$title,
                },
            },
        });
        this.UndoRedoService.add(changeContentTabIAction);
    }
    /**
     * Handle proxy changes to made undo/redo
     * @param value
     */
    handleActionsChanges(type, value) {
        if (!this.isBuilderUndoRedoActionEnabled) {
            return;
        }
        const currentState = angular.copy(this.state);
        const actionType = angular.copy(this.state[type]).length < value.length
            ? 'add'
            : 'delete';
        const segmentPayload = {
            blockId: currentState.id,
            blockName: currentState.$title,
            actionType: actionType,
        };
        const changeContentTabIAction = new ActionTabIAction({
            execute: (data) => {
                this.state[type] = data.after;
                data.after.forEach(item => {
                    item.settings = item.settings || {};
                });
                this.updateAndSaveState();
                validateTab(this.state);
                this.trackBlockActionRedo(true, segmentPayload);
            },
            undo: (data) => {
                /*
                * It has been created an validation which if the data after is greather than
                * data before (length), it's happening a block exclusion action, so, we
                * filter the opened sideabars to filter sidebars which is an Action Sidebar
                * and we use the method to close it.
                */
                const openedSidebarsIds = this.SidebarContentService.getSidebars().map(({ sidebarId }) => sidebarId).filter(s => s != undefined);
                const actionsId = data.before.map(({ $id }) => $id);
                openedSidebarsIds?.forEach(openedSidebarId => {
                    if (!actionsId.includes(openedSidebarId)) {
                        const sidebarToBeClosed = this.SidebarContentService
                            .getSidebars()
                            .find(({ sidebarId }) => sidebarId == openedSidebarId);
                        this.SidebarContentService.cleanAndClose(undefined, sidebarToBeClosed);
                    }
                });
                this.state[type] = data.before;
                this.updateAndSaveState();
                validateTab(this.state);
                this.trackBlockActionUndo(true, segmentPayload);
            },
            data: {
                after: angular.copy(value),
                before: angular.copy(this.state[type]),
                state: {
                    id: this.state.id,
                    $title: this.state.$title,
                },
            },
        });
        this.UndoRedoService.add(changeContentTabIAction);
    }
    removeTagUndoItem(tagId) {
        let itemIndex = 0;
        let userAction;
        this.UndoRedoService.getNormalStack().getStore().map(stackItem => {
            if (!Object.keys(stackItem.data)) {
                return;
            }
            if (Array.isArray(Object(stackItem?.data)?.after)) {
                Object(stackItem.data).after.map(tagAction => {
                    if (tagAction?.id == tagId) {
                        this.UndoRedoService.getNormalStack().removeItemByIndex(itemIndex);
                        userAction = stackItem;
                    }
                });
            }
            itemIndex += 1;
        });
        return userAction;
    }
    handleTagActionChanges(tagAction, tagChanged = undefined) {
        if (!this.isBuilderUndoRedoBlockTagEnabled) {
            return;
        }
        const currentState = angular.copy(this.state);
        const oldState = angular.copy({
            ...this.oldState,
            $tags: tagAction == TagChangesAction.ChangeTagColor
                ? Object(this.removeTagUndoItem(tagChanged.props.id).data)?.before
                : this.oldState.$tags,
        });
        const changeStateTagsIAction = new StateTagsIAction({
            execute: (data) => {
                builderStore.setState({
                    ...currentState,
                    $tags: data.after,
                });
            },
            undo: (data) => {
                builderStore.setState({
                    ...currentState,
                    $tags: data.before,
                });
            },
            data: {
                after: currentState.$tags,
                before: oldState.$tags,
                state: {
                    id: currentState.id,
                    $title: currentState.$title,
                },
            },
        });
        this.UndoRedoService.add(changeStateTagsIAction);
    }
    handleTitleActionChanges() {
        if (!this.isBuilderUndoRedoBlockNameEnabled) {
            return;
        }
        const currentState = angular.copy(this.state);
        const changeStateTitleIAction = new StateTitleIAction({
            execute: (data) => {
                builderStore.setState({
                    ...currentState,
                    $title: data.after,
                });
            },
            undo: (data) => {
                builderStore.setState({
                    ...currentState,
                    $title: data.before,
                });
            },
            data: {
                after: this.state.$title,
                before: this.oldState.$title,
                state: {
                    id: currentState.id,
                    $title: currentState.$title,
                },
            },
        });
        this.UndoRedoService.add(changeStateTitleIAction);
    }
    isDefaultNode() {
        const listDefaultNodeId = [STATE_ID_ONBOARDING, STATE_ID_FALLBACK, STATE_ID_END];
        return listDefaultNodeId.some((element) => element === this.state.id);
    }
    onContentAction($action) {
        if ($action.constructor !== ContentUpdateAndSave) {
            throw new Error('Unrecognized content action');
        }
        this.updateAndSaveState();
    }
    async onOutputAction($action) {
        switch ($action.constructor) {
            case OutputUpdateAndSaveState:
                this.updateAndSaveState();
                break;
            case OutputChange:
                await this.$onOutputChange($action);
                break;
            case OutputAddNewState:
                await this.$onAddNewState($action);
                break;
            case OutputAddNewSurvey:
                await this.$onAddNewSurvey($action);
                break;
            default:
                throw new Error('Unrecognized output action');
        }
    }
    async onActionDispatched($action) {
        switch ($action.constructor) {
            case ActionsUpdateAndSaveState:
                await this.updateAndSaveState();
                break;
            default:
                throw new Error(`Unrecognized action dispatcher type: ${$action.constructor}`);
        }
    }
    async updateAndSaveState() {
        if (this.state.$title != this.oldState.$title) {
            this.handleTitleActionChanges();
            this.trackBlockNameEdited();
        }
        this.oldState = { ...this.state };
        await this.$onStateChanged(this.state);
    }
    onTagAdded({ tag }) {
        this.TagsService.add(tag);
        this.handleTagActionChanges(TagChangesAction.AddTag);
        this.trackBlockTagged();
        this.updateAndSaveState();
    }
    onTagRemoved() {
        this.handleTagActionChanges(TagChangesAction.RemoveTag);
        this.updateAndSaveState();
    }
    onSelectTagColor({ tag }) {
        this.TagsService.changeBackground(tag);
        this.handleTagActionChanges(TagChangesAction.ChangeTagColor, tag);
        this.updateAndSaveState();
    }
    async closeSidebar() {
        try {
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
    // Segment Methods
    trackBlockTagged() {
        this.BuilderSegmentService.trackBlockTagged({
            BlockID: this.state.id,
            ShortNameOfSubflow: this.state.shortNameOfSubflow,
        }, true);
    }
    trackBlockNameEdited() {
        this.BuilderSegmentService.trackBlockNameEdited({
            BlockID: this.state.id,
            ShortNameOfSubflow: this.state.shortNameOfSubflow,
        }, true);
    }
    trackBlockActionUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockActionUndo(segmentPayload, success);
    }
    trackBlockActionRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockActionRedo(segmentPayload, success);
    }
    loadPaymentConfigurationFromState() {
        if (!this.state || !this.state.$leavingCustomActions) {
            this.paymentConfiguration = { configuration: {}, customize: {}, paymentMethod: {}, information: {} };
            return;
        }
        if (!this.paymentConfiguration) {
            this.paymentConfiguration = { configuration: {}, customize: {}, paymentMethod: {}, information: {} };
        }
        const configurationData = this.getPaymentVariableValue('configurationData');
        const paymentMethodData = this.getPaymentVariableValue('paymentMethodData');
        const customizeData = this.getPaymentVariableValue('customizeData');
        if (configurationData) {
            this.paymentConfiguration.configuration = configurationData;
        }
        if (paymentMethodData) {
            this.paymentConfiguration.paymentMethod = paymentMethodData;
        }
        if (customizeData) {
            this.paymentConfiguration.customize = customizeData;
        }
    }
    updateBlockVersion(block) {
        try {
            if (!block)
                return;
            this.StudioVersionService.updateAiBlockVersion([block]);
            this.updateAndSaveState();
            this.hasAgentBlockToUpdate = this.BuilderAiAgentService.isAgentBlockOutdated(this.state);
            this.BlipToastService.show('success', {
                title: this.$translate.instant('versioning.toast.successTitle'),
                msg: this.$translate.instant('versioning.toast.successMessage')
            });
        }
        catch (error) {
            this.BlipToastService.show('danger', {
                title: this.$translate.instant('versioning.toast.errorTitle'),
                msg: this.$translate.instant('versioning.toast.errorMessage')
            });
        }
    }
    getPaymentVariableValue(variableName) {
        if (!this.state || !this.state.$leavingCustomActions)
            return null;
        const setVariableAction = this.state.$leavingCustomActions.find(action => action.type === ActionType.SetVariable &&
            action.settings &&
            action.settings.variable === variableName);
        if (setVariableAction && setVariableAction.settings && setVariableAction.settings.value) {
            try {
                if (typeof setVariableAction.settings.value === 'string') {
                    if (setVariableAction.settings.value.trim().startsWith('{') ||
                        setVariableAction.settings.value.trim().startsWith('[')) {
                        return JSON.parse(setVariableAction.settings.value);
                    }
                }
                return setVariableAction.settings.value;
            }
            catch (error) {
                return null;
            }
        }
        return null;
    }
    updatePaymentSetVariableAction(variableName, data) {
        if (!this.state || !this.state.$leavingCustomActions)
            return;
        const setVariableAction = this.state.$leavingCustomActions.find(action => action.type === ActionType.SetVariable &&
            action.settings &&
            action.settings.variable === variableName);
        if (setVariableAction && setVariableAction.settings) {
            setVariableAction.settings.value = JSON.stringify(data);
        }
    }
    async setAgentConfigurationContent() {
        this.BuilderAiAgentService.setAgentConfigurationOnState(this.agentConfiguration, this.state);
        this.updateAndSaveState();
    }
    async setPaymentConfigurationContent() {
        this.updateAndSaveState();
    }
    updateAgentState($action, generatedMCPResource) {
        this.BuilderAiAgentService.addMcpResourceToTools(generatedMCPResource, this.agentConfiguration);
        this.state.$localCustomActions = this.state.$localCustomActions.map((a) => {
            if (a.$id === $action.$id) {
                return $action;
            }
            return a;
        });
        if (!this.state.$toolActionsMapping?.builder) {
            this.state.$toolActionsMapping = {
                builder: {
                    uuid: generatedMCPResource.uuid,
                },
            };
        }
    }
    openModal(modalId) {
        this.AiAgentSidebarStateService.open(modalId, null);
    }
    closeModal() {
        this.AiAgentSidebarStateService.close();
    }
    isModalOpen(modalId) {
        return this.AiAgentSidebarStateService.isOpen(modalId);
    }
    openKnowledgeBaseCatalogSelector() {
        this.isKnowledgeBaseCatalogSelectorOpen = true;
    }
    closeKnowledgeBaseCatalogSelector() {
        this.isKnowledgeBaseCatalogSelectorOpen = false;
    }
}
// DI annotation for minification safety - order must match constructor parameters
BuilderSidebarController.$inject = [
    'TagsService',
    'close',
    'targetState',
    '$scope',
    'states',
    'BuilderSegmentService',
    'ActionContentService',
    'application',
    '$onStateChanged',
    '$onOutputChange',
    '$onAddNewState',
    '$onAddNewSurvey',
    'ChatService',
    'AccountService2',
    'UndoRedoService',
    'SmartSalesService',
    'AnswersService',
    '$state',
    '$rootScope',
    'AutoSaveService',
    'TranslateService',
    '$translate',
    'SidebarContentService',
    'ExclusiveComponentsService',
    'BuilderAiAgentService',
    'BlipToastService',
    'AiAgentSidebarStateService',
    'AgentSegmentService',
    'PaymentSegmentService',
    'StudioService',
    '$timeout',
    'StudioVersionService',
];
